/**
 * Keycloak realm role that grants developer-only access (e.g. the audit log). Managed in Keycloak,
 * independent of the DB-based AppUserRole business roles — see CurrentUserState.isDeveloper().
 */
export const DEVELOPER_REALM_ROLE = 'developer';
